import { render, staticRenderFns } from "./mammals.vue?vue&type=template&id=f9b05c92&scoped=true&"
import script from "./mammals.vue?vue&type=script&lang=js&"
export * from "./mammals.vue?vue&type=script&lang=js&"
import style0 from "./mammals.vue?vue&type=style&index=0&id=f9b05c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b05c92",
  null
  
)

export default component.exports